export const Dashboard = () => (
    null
);
